export default "__VITE_ASSET__Cj692tx5__"